function getImageLink(link) {
    return link && link.replace('http://188.121.118.80', process.env.NEXT_PUBLIC_REST_URL);
}

export default getImageLink;
